import { useState } from "react";

import { Alert, Button, Divider, Stack, Var } from "@seneca/senekit";

import { LogInLink, TermsAndConditionsLink } from "./form";
import Loading from "./form/Loading";
import { SignUpCard, SignUpHeading } from "./Layout";
import { CardState, useGetSignUpCardState } from "./logic/card-state";
import SignUpPreconnectedParent from "./passwordless/SignUpPreconnectedParent";
import SignUpParentEmailForm from "./SignUpParentEmailForm";
import SignUpParentSSO from "./SignUpParentSSO";

export default function SignUpParent() {
  const { state, data, emailFromState, errorMessage } = useGetSignUpCardState();

  const [hasClickedPasswordSignUp, setHasClickedPasswordSignUp] =
    useState(false);

  const shouldShowPasswordSignUp =
    state === CardState.showPasswordSignUp || hasClickedPasswordSignUp;

  const email = emailFromState || data?.email;
  const childName = data?.childName || "your child";

  return (
    <SignUpCard>
      {errorMessage && <ErrorAlert>{errorMessage}</ErrorAlert>}
      <SignUpHeading>
        Sign up to monitor <Var>{childName}</Var>'s progress
      </SignUpHeading>
      {state === CardState.loading ? (
        <Loading />
      ) : state === CardState.showPasswordlessSignUp ? (
        <SignUpPreconnectedParent data={data} />
      ) : shouldShowPasswordSignUp ? (
        <SignUpParentEmailForm email={email} />
      ) : (
        <DefaultCardContent
          showPasswordSignUp={() => setHasClickedPasswordSignUp(true)}
        />
      )}
    </SignUpCard>
  );
}

function DefaultCardContent({
  showPasswordSignUp
}: {
  showPasswordSignUp: () => void;
}) {
  return (
    <Stack space="xxlarge">
      <SignUpParentSSO />
      <Divider direction="horizontal" includeOr />
      <Button width="100%" onClick={showPasswordSignUp}>
        Sign up with email
      </Button>
      <TermsAndConditionsLink />
      <LogInLink />
    </Stack>
  );
}

function ErrorAlert({ children }: { children: React.ReactNode }) {
  return (
    <Alert iconName="exclamationCircle" tone="error">
      {children}
    </Alert>
  );
}
